
import ogPagesMixins from '@/mixins/ogPagesMixins'
export default {
  mixins: [ogPagesMixins],
  props: {
    stream: {
      type: Object,
      default: null,
    },
    companys: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    seoTitle() {
      return `${this.stream?.stream?.title} — компании | Мегасреда`
    },
    seoDescription() {
      return `Компании имеющие навык работы с продуктом - ${this.stream?.stream?.title}`
    },
    seoH1() {
      return `Компании использующие продукт ${this.stream?.stream?.title} в своей работе`
    },
    seoImage() {
      return {
        url: `https://api.megasreda.ru/image/ogimage/stream/${this.stream?.stream?.id}.jpg`,
        urlVk: `https://api.megasreda.ru/image/ogimage/stream/vk/${this.stream?.stream?.id}.jpg`,
        urlTw: `https://api.megasreda.ru/image/ogimage/stream/${this.stream?.stream?.id}.jpg`,
        type: 'image/jpeg',
        width: 1200,
        height: 630,
      }
    },
  },
}
